import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/reproductions",
        name: "reproductions",
        component: () => import("@/modules/Reproductions/pages/ReproductionList.vue"),
        meta: {
            requiresAuth: true,
            title: "reproductions.title_management",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.reproductions" },
            ],
        },
    },
    {
        path: "/reproductions/create",
        name: "reproductions-create",
        component: () => import("@/modules/Reproductions/pages/ReproductionForm.vue"),
        meta: {
            requiresAuth: true,
            title: "reproductions.create",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.reproductions", to: "/reproductions" },
                { label: "reproductions.create" },
            ],
        },
    },
    {
        path: "/reproductions/:id",
        name: "reproductions-view",
        component: () => import("@/modules/Reproductions/pages/ReproductionForm.vue"),
        meta: {
            requiresAuth: true,
            title: "reproductions.view",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.reproductions", to: "/reproductions" },
                { label: "reproductions.view" },
            ],
        },
    },
];

export default routes;
